'use strict';

import $ from 'jquery';
// import 'select2';
import 'bootstrap-daterangepicker';
// import Pikaday from 'pikaday';
// import moment from 'moment';

export default class Filter {
  constructor() {
    if($('.filter').length) {
      $('#daterange').daterangepicker({
          locale: {
            format: 'DD-MM-YYYY'
          },
          // "autoApply": true,
          "linkedCalendars": false,
          "showCustomRangeLabel": false,
          "autoUpdateInput": false,
          "locale": {
              "cancelLabel": 'Clear'
          }

      }, function(start, end, label) {
        console.log("New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')");
      });

      $('#daterange').on('apply.daterangepicker', function(ev, picker) {
          $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
      });

      $('#daterange').on('cancel.daterangepicker', function(ev, picker) {
          $(this).val('');
      });
    }

  }
}
